import * as TypeGraphQL from "type-graphql";
export var MLTrainingDataScalarFieldEnum;
(function (MLTrainingDataScalarFieldEnum) {
    MLTrainingDataScalarFieldEnum["id"] = "id";
    MLTrainingDataScalarFieldEnum["signalId"] = "signalId";
    MLTrainingDataScalarFieldEnum["symbol"] = "symbol";
    MLTrainingDataScalarFieldEnum["signalType"] = "signalType";
    MLTrainingDataScalarFieldEnum["signalStrength"] = "signalStrength";
    MLTrainingDataScalarFieldEnum["predictedConfidence"] = "predictedConfidence";
    MLTrainingDataScalarFieldEnum["actualOutcomeSuccess"] = "actualOutcomeSuccess";
    MLTrainingDataScalarFieldEnum["actualOutcomeProfitLoss"] = "actualOutcomeProfitLoss";
    MLTrainingDataScalarFieldEnum["actualOutcomeReturnPercent"] = "actualOutcomeReturnPercent";
    MLTrainingDataScalarFieldEnum["actualOutcomeSharpeRatio"] = "actualOutcomeSharpeRatio";
    MLTrainingDataScalarFieldEnum["actualOutcomeMaxDrawdown"] = "actualOutcomeMaxDrawdown";
    MLTrainingDataScalarFieldEnum["actualOutcomeDaysHeld"] = "actualOutcomeDaysHeld";
    MLTrainingDataScalarFieldEnum["actualOutcomeExitReason"] = "actualOutcomeExitReason";
    MLTrainingDataScalarFieldEnum["actualOutcomeQuality"] = "actualOutcomeQuality";
    MLTrainingDataScalarFieldEnum["entryPrice"] = "entryPrice";
    MLTrainingDataScalarFieldEnum["exitPrice"] = "exitPrice";
    MLTrainingDataScalarFieldEnum["entryTime"] = "entryTime";
    MLTrainingDataScalarFieldEnum["exitTime"] = "exitTime";
    MLTrainingDataScalarFieldEnum["holdingPeriod"] = "holdingPeriod";
    MLTrainingDataScalarFieldEnum["returnPercent"] = "returnPercent";
    MLTrainingDataScalarFieldEnum["maxDrawdown"] = "maxDrawdown";
    MLTrainingDataScalarFieldEnum["maxGain"] = "maxGain";
    MLTrainingDataScalarFieldEnum["volatilityDuringHold"] = "volatilityDuringHold";
    MLTrainingDataScalarFieldEnum["marketContextRegime"] = "marketContextRegime";
    MLTrainingDataScalarFieldEnum["marketContextVolatility"] = "marketContextVolatility";
    MLTrainingDataScalarFieldEnum["marketContextSentiment"] = "marketContextSentiment";
    MLTrainingDataScalarFieldEnum["marketContextVolume"] = "marketContextVolume";
    MLTrainingDataScalarFieldEnum["marketContextCorrelation"] = "marketContextCorrelation";
    MLTrainingDataScalarFieldEnum["marketContextBreadth"] = "marketContextBreadth";
    MLTrainingDataScalarFieldEnum["signalFeatures"] = "signalFeatures";
    MLTrainingDataScalarFieldEnum["executionMetricsLatency"] = "executionMetricsLatency";
    MLTrainingDataScalarFieldEnum["executionMetricsSlippage"] = "executionMetricsSlippage";
    MLTrainingDataScalarFieldEnum["executionMetricsMarketImpact"] = "executionMetricsMarketImpact";
    MLTrainingDataScalarFieldEnum["executionMetricsTimingAccuracy"] = "executionMetricsTimingAccuracy";
    MLTrainingDataScalarFieldEnum["executionMetricsFillQuality"] = "executionMetricsFillQuality";
    MLTrainingDataScalarFieldEnum["executionMetricsOrderSize"] = "executionMetricsOrderSize";
    MLTrainingDataScalarFieldEnum["executionMetricsLiquidityScore"] = "executionMetricsLiquidityScore";
    MLTrainingDataScalarFieldEnum["slippageAnalysisExpected"] = "slippageAnalysisExpected";
    MLTrainingDataScalarFieldEnum["slippageAnalysisActual"] = "slippageAnalysisActual";
    MLTrainingDataScalarFieldEnum["slippageAnalysisDifference"] = "slippageAnalysisDifference";
    MLTrainingDataScalarFieldEnum["slippageAnalysisMarketConditions"] = "slippageAnalysisMarketConditions";
    MLTrainingDataScalarFieldEnum["slippageAnalysisTimeOfExecution"] = "slippageAnalysisTimeOfExecution";
    MLTrainingDataScalarFieldEnum["slippageAnalysisVolumeAtExecution"] = "slippageAnalysisVolumeAtExecution";
    MLTrainingDataScalarFieldEnum["slippageAnalysisSpreadAtExecution"] = "slippageAnalysisSpreadAtExecution";
    MLTrainingDataScalarFieldEnum["attributionAlphaGeneration"] = "attributionAlphaGeneration";
    MLTrainingDataScalarFieldEnum["attributionBetaExposure"] = "attributionBetaExposure";
    MLTrainingDataScalarFieldEnum["attributionFactorExposures"] = "attributionFactorExposures";
    MLTrainingDataScalarFieldEnum["attributionSkillVsLuck"] = "attributionSkillVsLuck";
    MLTrainingDataScalarFieldEnum["attributionInformationRatio"] = "attributionInformationRatio";
    MLTrainingDataScalarFieldEnum["createdAt"] = "createdAt";
    MLTrainingDataScalarFieldEnum["updatedAt"] = "updatedAt";
})(MLTrainingDataScalarFieldEnum || (MLTrainingDataScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(MLTrainingDataScalarFieldEnum, {
    name: "MLTrainingDataScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=MLTrainingDataScalarFieldEnum.js.map